import React, { useState, useCallback, useEffect, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { Text } from 'rebass'
import { TextYellowLightColor } from '../../../components/Text'
import Row from '../../../components/Row'
import { getBestNfts } from '../../../service/nft'
import { useActiveWeb3React } from '../../../hooks'
import ArtworkCard from '../../../components/Collection/ArtworkCard'
import { AuctionBake, ArtworkProps } from '../../../constants/artwork'
import { contractAddresses } from '../../../sushi/lib/constants'

// swiper
import { windowSize } from '../../../utils/func'
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper.min.css'
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
SwiperCore.use([Navigation, Pagination, Autoplay]);

const SellingNftwapper = styled.div`
  max-width: 1440px;
  margin: auto;
  margin-top: 53px;
  position: relative;
  box-sizing: border-box;
  padding: 0px 20px;
`
const NextRightIcon = styled.img`
  width: 50px;
  height: 50px;
  position: absolute;
  z-index: 1;
  right: 0px;
  top: 280px;
  cursor: pointer;
`

const PrevLeftIcon = styled.img`
width: 50px;
height: 50px;
position: absolute;
z-index: 1;
left: 0px;
top: 280px;
cursor: pointer;
`

const Title = styled(Row)`
  
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  color: ${({ theme }) => theme.bsText32};
`
const SwiperWrapper = styled(Row)`
  position: relative;
  display: flex;
  grid-row-gap: 20px;
  grid-column-gap: 20px;
  justify-content: flex-start;
  grid-template-columns: repeat(auto-fill, 272px);
  flex-wrap: nowrap;
  overflow: auto;
  margin-top: 40px;
  max-width: 100%;
  min-height: 392px;
  height: 430px;
  .swiper-pagination {
    display: none;
  }
  .swiper-pagination-bullet {
    background: rgba(255, 255, 255, 0.9);
  }
  .swiper-pagination-bullet-active {
    background: #fffdfa;
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    justify-content: center;
  `}
  .swiper-slide{
    padding: 0px 1px;
    box-sizing: border-box;
  }
`

const ArtWorkRank = styled.div<{index: number}>`
  position: relative;
  width: 272px;
  height: 392px;
  padding-top: 32px;
  margin-top: 32px;
  box-sizing: border-box;
  z-index: 1;
  background-color: ${({ theme }) => theme.bsBg36};
  border-radius: 8px;
  box-shadow: 0px 0px 10px rgb(171 133 115 / 30%);
  &:before{
    content:  ${({ index }) => index < 3 ? 'url(/images/icon/border.png)' : ''};
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: -1;
  }
  .ArtworkCard{
    width: 270px;
    margin: auto;
  }
`

const RankIndex = styled.div`
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.bsBg29};
  border-radius: 100%;
  position: absolute;
  z-index: 2;
  top: 15px;
  left: 5px;
  width: 36px;
  height: 36px;
  
  border: 0.934023px solid #FFCD84;
  font-style: normal;
  font-weight: 500;
  font-size: 20.9417px;
  line-height: 25px;
  text-align: center;
  line-height: 36px;
  color: #FF7A00;
`

const RankIcon = styled.img`
  position: absolute;
  z-index: 2;
  top: 0px;
  left: 8px;
`

export default function SellingNft() {
  const theme = useContext(ThemeContext)
  const [loading, setLoading] = useState(false)
  const { account, chainId } = useActiveWeb3React()
  const [bestSellNfts, setBestSellNfts] = useState([])
  const exchangeNfts2Address = contractAddresses.exchangeNFTs2[chainId as number]

  const fetchArtworks = useCallback(() => {
    setLoading(true)
    getBestNfts(chainId as number, {
      nftTypes: '3,111',
      limit: 10,
      sortName: 'volumeTraded',
      sortBy: 'desc',
      status: 1
    }, (err: any, data: any) => {
      if (err) return
      if (data.code !== 0) return
      let dataAry = data.data.list || []
      const artworks = dataAry.map((d: ArtworkProps, index: any) => {
        let level = (((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake))
        || (d.price && Number(d.price))
        || ((d.auctionPrice && Number(d.auctionPrice)) && !Number(d.price) && (d.owner !== account))) && d.exchangeAddress?.toLowerCase() !== exchangeNfts2Address.toLowerCase() ? 'v2' : 'v3'
        return {
          ...d,
          tokenId: d.nftId,
          nftLevel: level,
          nftType: d.nftType,
          maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice,
          ...((d.price && Number(d.price)) ? {price: d.price.toString()} : {price: ''}),
          ...((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? {auctionPrice: d.auctionPrice.toString()} : {auctionPrice: ''})
        }
      })
      setBestSellNfts(artworks)
      setLoading(false)
    })
  }, [getBestNfts, chainId])

  useEffect(() => {
    fetchArtworks()
  }, [fetchArtworks])

  // swiper
  const upToSmall = 500
  const upToMedium = 960
  const upMoreMedium = 1300
  const upToExtraLarge = 1440
  const upToLessLarge = 1520
  const upToMoreLarge = 1600
  const upToLarge = 1750
  const emptySwiper: any = null
  const [swiper, setSwiper] = useState(emptySwiper)
  const [width, setWidth] = useState(windowSize().w)
  const params = {
    loop: true,
    slidesPerView: 5,
    spaceBetween: 16,
    pagination: {
      clickable: true,
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    observer: true,
    observeParents: true,
    onSwiper: setSwiper
  }
  useEffect(() => {
    if (swiper) {
      if(width <= upToSmall){
        swiper.params.slidesPerView = 1.1
        swiper.params.spaceBetween = 16
      }else if(width <= upToMedium){
        swiper.params.slidesPerView = 2
        swiper.params.spaceBetween = 16
      }else if(width <= upMoreMedium){
        swiper.params.slidesPerView = 3
        swiper.params.spaceBetween = 16
      }else if(width <= upToExtraLarge){
        swiper.params.slidesPerView = 4
        swiper.params.spaceBetween = 16
      }else if(width <= upToLessLarge){
        swiper.params.slidesPerView = 4.2
        swiper.params.spaceBetween = 16
      }else if(width <= upToMoreLarge){
        swiper.params.slidesPerView = 4.5
        swiper.params.spaceBetween = 16
      }else if(width <= upToLarge){
        swiper.params.slidesPerView = 4.8
        swiper.params.spaceBetween = 16
      }else{
        swiper.params.slidesPerView = 5
        swiper.params.spaceBetween = 16
      }
      swiper.autoplay.stop()
    }
  }, [width, swiper])

  const handleResize = useCallback(() => {
    const size = windowSize()
    setWidth(size.w)
  }, [width])

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [handleResize])

  useEffect(() => {
    if(swiper){
      swiper.slideTo(5, 1000, true);
    }
  }, [swiper, chainId])

  const slideNext = useCallback(() => {
    swiper.slideNext()
  }, [swiper])

  const slidePrev = useCallback(() => {
    swiper.slidePrev()
  }, [swiper])

  return (
    <SellingNftwapper>
      <Title>
        Best-selling &nbsp;<TextYellowLightColor>NFTs</TextYellowLightColor>
      </Title>
      <SwiperWrapper>
        <Swiper {...params}>
          {
            loading ? (
              <Text
                marginTop={20} 
                textAlign={'center'} 
                fontFamily={'Baloo Da'}>
                  loading...
              </Text>
              // <video src="https://cloud.protopie.io/p/ee2c5329e2/r/8e2b3e6e" width={120} height={126} autoPlay loop/>
            ) : bestSellNfts.map((d:any,index: any) => {
              return (
                <SwiperSlide key={index}>
                  {
                    index < 3 ? (
                      <RankIcon src={`/images/icon/rank${index + 1}.png`}/> 
                    ) : (
                      <RankIndex>{index + 1}</RankIndex>
                    )
                  }
                  <ArtWorkRank index={index}>
                    <ArtworkCard artwork={d} className='ArtworkCard' width={256}></ArtworkCard>
                  </ArtWorkRank>
                </SwiperSlide>
              )
            })
          }
        </Swiper>
      </SwiperWrapper>
      <NextRightIcon src={theme.darkMode ? "/images/icon/next-dark.png" : "/images/icon/next.png"} onClick={slideNext}/>
      <PrevLeftIcon src={theme.darkMode ? "/images/icon/prev-dark.png" : "/images/icon/prev.png"} onClick={slidePrev}/>
    </SellingNftwapper>
  )
}

